<div class="message-prompt danger">
    <div class="background-danger">
      <img src="assets/images/warning.svg"
           class="error-red">
    </div>
    <div class="message">{{ errorMessage }}</div>
    <ng-content></ng-content>
  </div>
